<template>
	<div class="content background1">
		<div class="tableBox11">
			<div class="tableMes">
				<div class="table" style="padding: 0;background-color:#f7f7f7;">
					<div class="treeMes">
						<p class="title">{{$t('label_102')}}</p>
						<div class="chooseBox spaceBetween" style="background-color:#f7f7f7;">
							<div class="selectBox">
								<div>
									<div class="selectChoose">
										<div class="selectText" style="width: 120px;">
											<p>{{$t('label_106')}}</p>
										</div>
										<div class="select" style="width:230px">
											<el-input v-model="searchDataList.name" clearable></el-input>
										</div>
									</div>
								</div>
								<div>
									<div class="selectChoose">
										<div class="selectText">
											<p>{{$t('label_567')}}</p>
										</div>
										<div class="select" style="width:300px">
											<el-autocomplete style="width:100%" v-model="searchDataList.deptName"
												:fetch-suggestions="querySearchAsync1" :placeholder="$t('input_14')"
												:trigger-on-focus="false" @select="handleSelect1" value-key="name"
												@clear="clearSearch(1)" clearable>
											</el-autocomplete>
										</div>
									</div>
								</div>
								<div>
									<div class="selectChoose">
										<div class="selectText">
											<p>{{$t('label_109')}}</p>
										</div>
										<div class="select" style="width:300px">
											<el-autocomplete style="width:100%" v-model="searchDataList.userName"
												:fetch-suggestions="querySearchAsync2" :placeholder="$t('input_15')"
												:trigger-on-focus="false" @select="handleSelect2" value-key="fullName"
												@clear="clearSearch(2)" clearable>
											</el-autocomplete>
										</div>
									</div>
								</div>
							</div>
							<div class="buttonBox">
								<div>
									<div class="chooseButton sendButton"
										@click="search({pageNum: 1,pageSize:pageSize,})"><i
											class="el-icon-search"></i>{{$t('btn_2')}}</div>
								</div>
							</div>
						</div>
						<div class="spotStatusNumList1">
							<div class="statusMesBox1" v-for="(item,index) in spotStatusNumList" :key="index"
								:class="item.check==true?'check':''">
								<div class="iconBox" :style="{'background':item.color}"><i :class="item.icon"></i></div>
								<div class="textBox">
									<p>{{item.text}}</p>
									<p class="num" :class="item.check==true?'greenFont':''">{{item.num}}</p>
								</div>
								<div class="checkBox">
									<el-checkbox label="" v-model="item.check"></el-checkbox>
								</div>
							</div>
						</div>

						<div class="spotMes2Box" style="position: relative;height: calc(100% - 255px);">
							<!--button按钮-->
							<div class="buttonBox" style="margin-bottom: 10px;">
								<div>
									<div class="chooseButton searchButton" v-if="MenuRoleList.indexOf('172')>=0"
										@click="addFactory($t('btn_14'))">
										<i class="el-icon-circle-plus-outline"></i>{{$t('btn_14')}}
									</div>
									<div class="chooseButton searchButton" v-if="MenuRoleList.indexOf('173')>=0"
										@click="addFactory($t('btn_15'))">
										<i class="el-icon-edit-outline"></i>{{$t('btn_15')}}
									</div>
									<div class="chooseButton deleteButton" v-if="MenuRoleList.indexOf('174')>=0"
										@click="del"><i class="el-icon-delete"></i>{{$t('btn_16')}}</div>
									<div class="chooseButton searchButton" v-if="MenuRoleList.indexOf('175')>=0"
										@click="updateStatus(1)"><i class="el-icon-circle-check"></i>{{$t('btn_36')}}
									</div>
									<div class="chooseButton deleteButton" v-if="MenuRoleList.indexOf('176')>=0"
										@click="updateStatus(0)"><i class="el-icon-circle-close"></i>{{$t('btn_37')}}
									</div>
									<div class="chooseButton searchButton" v-if="MenuRoleList.indexOf('173')>=0"
										@click="look">
										<i class="el-icon-view"></i>{{$t('btn_38')}}
									</div>
								</div>
							</div>

							<!--table头部-->
							<div class="tableList" style="height: calc(100% - 95px);top: 50px;padding-top: 0px">
								<!-- @current-change="handleCurrentChangeTree" -->
								<el-table :empty-text="$t('label_357')" ref="singleTable" :data="tableDatadialog" highlight-current-row

									style="width: 100%;margin: 5px;overflow: auto;" height="100%"
									:header-cell-style="{'background-color': '#45494f','color': '#ffffff',}"
									@selection-change="handleChange">
									<el-table-column type="selection" width="55" align="center">
									</el-table-column>
									<el-table-column header-align="center" align="center" :label="$t('label_369') + '.'" type="index"
										:index="getIndex" width="50">
									</el-table-column>
									<el-table-column prop="name" :label="$t('label_106')" align="center">
									</el-table-column>
									<el-table-column prop="deptName" :label="$t('label_567')" align="center">
									</el-table-column>
									<el-table-column prop="userName" :label="$t('label_109')" align="center">
									</el-table-column>
									<el-table-column prop="deviceNum" :label="$t('label_477')" align="center">
									</el-table-column>
									<el-table-column prop="infoNum" :label="$t('label_115')" align="center">
									</el-table-column>
									<el-table-column prop="inspectionTime" :label="$t('label_118')" align="center">
									</el-table-column>
									<el-table-column prop="inspectionStatus" :label="$t('label_123')" align="center">
										<template slot-scope="scope">
											<p :style="{color:(scope.row.inspectionStatus=='2'?'green':'red')}">
												{{scope.row.inspectionStatus=='2'?$t('btn_36'):$t('btn_37')}}
											</p>
										</template>
									</el-table-column>
								</el-table>
							</div>

              <div style="position: absolute;bottom: 10px;left: 30%">
                <Page class="item" ref="pageModel" :total="pageCount" :display="pageSize"
                      :pagegroup="3" :currentspage="1" @parentMethod="searchPage"></Page>
              </div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 弹框 -->
		<el-dialog :title="factoryDialogTitle" :visible.sync="dialogFactory" append-to-body
			:close-on-click-modal='false' width="1000px" top="5%" :before-close="handleClose" custom-class="dialogBox"
			style='height:900px;'>

			<div class="dialogBoxMes" style="padding:0 20px;">
				<div class="dialogMes">
					<div class="dialogMes">
						<p>{{$t('label_128')}}</p>
						<div class="mesInput">
							<el-input v-model="dialogFactoryEdit.name" :placeholder="$t('input_9')" @change="change"
								clearable></el-input>
						</div>
					</div>
					<div class="dialogMes" style="margin-left: 30px">
						<p>{{$t('label_567')}}</p>
						<div class="mesInput">
							<el-select style="width:230px;" @change="changeDeptName"
								v-model="dialogFactoryEdit.deptName" :disabled="!dialogFactoryAdd" :placeholder="$t('input_65')">
								<el-option v-for="item in dialogFactoryEditDeptName" :key="item.id" :label="item.name"
									:value="item.name">
								</el-option>
							</el-select>
						</div>
					</div>
					<div class="buttonBox" style="margin-bottom: 10px;margin-left: 75px;">
						<div>
							<div class="chooseButton searchButton" @click="updateStatus1(1)">{{$t('btn_36')}}</div>
							<div class="chooseButton searchButton" style="background-color: #C1C1C1;"
								@click="updateStatus1(0)">{{$t('btn_37')}}</div>
						</div>
					</div>
				</div>
				<div class="dialogMes">
					<div class="dialogMes">
						<p>{{$t('label_481')}}</p>
						<div class="mesInput">
							<el-date-picker style="width:210px;" value-format="yyyy-MM-dd HH:mm:ss"
								v-model="dialogFactoryEdit.inspectionBeginTime" type="datetime" :placeholder="$t('input_86')"
								@change="change">
							</el-date-picker>
						</div>
					</div>
					<div class="dialogMes" style="margin-left: 30px">
						<p>{{$t('label_109')}}</p>
						<div class="mesInput">
							<el-input style="width:230px;" :disabled="true" v-model="dialogFactoryEdit.userName"
								clearable></el-input>
						</div>
					</div>
					<div class="buttonBox" style="margin-bottom: 10px;margin-left: 115px;" v-if="commitFlag">
						<div>
							<div class="chooseButton searchButton" @click="insert"> {{$t('btn_39')}}</div>
						</div>
					</div>
				</div>
				<div class="treeMes">
					<div class="spotMesBox" style="height:100%;">
						<el-tabs v-model="activeNameSpot" @tab-click="tabClick">
							<el-tab-pane :label="$t('label_140')" name="inspectionEquipment" :disabled="dialogFactoryAdd">
								<inspectionEquipment :showButton="!dialogFactoryAdd" ref="inspectinDevice">
								</inspectionEquipment>
							</el-tab-pane>
							<el-tab-pane :label="$t('label_143')" name="pro" :disabled="dialogFactoryAdd">
								<inspectionProject ref="inspectinDevice1"></inspectionProject>
							</el-tab-pane>
							<el-tab-pane :label="$t('label_147')" name="bao" :disabled="dialogFactoryAdd">
								<div class="buttonBox" v-if="dialogFactoryEdit.inspectionStatus!=2">
									<div>
										<div class="chooseButton searchButton" @click="timeAdd"><i
												class="el-icon-circle-plus-outline"></i>{{$t('btn_14')}}</div>
										<div class="chooseButton searchButton" @click="timeUpdate"><i
												class="el-icon-edit-outline"></i>{{$t('btn_15')}}</div>
										<div class="chooseButton deleteButton" @click="timeDelete"><i
												class="el-icon-delete"></i>{{$t('btn_16')}}</div>
									</div>
								</div>
								<el-table :empty-text="$t('label_357')" ref="singleTable" :data="tableDataTreeTime" highlight-current-row
									@current-change="handleCurrentChangeTreeTime" border
									style="width: 100%;height:100%;margin: 10px 0px;" height="300px"
									:header-cell-style="{'background-color': '#45494f','color': '#ffffff',}">
									<el-table-column header-align="center" align="center" :label="$t('label_369') + '.'" type="index"
										:index="getIndexTime" width="50">
									</el-table-column>
									<el-table-column prop="beginTime" :label="$t('label_580')" align="center">
										<template slot-scope="scope">
											<p>{{scope.row.beginTime}}
												<span v-if="scope.row.beginTimeOverDay==1">{{$t('label_151')}}</span>
											</p>
										</template>
									</el-table-column>
									<el-table-column prop="endTime" :label="$t('label_585')" align="center">
										<template slot-scope="scope">
											<p>{{scope.row.endTime}}
												<span v-if="scope.row.endTimeOverDay==1">{{$t('label_151')}}</span>
											</p>
										</template>
									</el-table-column>
									<el-table-column prop="duration" :label="$t('label_155')" align="center">
									</el-table-column>
									<el-table-column prop="userName" :label="$t('label_109')" align="center">
									</el-table-column>
								</el-table>
								<Page class="item" ref="pageModelTime" :total="pageCountTime" :display="pageSizeTime"
									:pagegroup="3" :currentspage="1" @parentMethod="selectTime"></Page>
							</el-tab-pane>
							<el-tab-pane :label="$t('btn_59')" :disabled="dialogFactoryAdd" name="xun"
								v-if="MenuRoleList.indexOf('21')>=0">
								<div style="height:370px;">
									<calendar ref="calendarDisplay" @saveRest="saveRest" :showButton="false"
										:showEdit="dialogFactoryEdit.inspectionStatus!=2" :calendarData="calendarData"
										@selectRest="selectRest"></calendar>
								</div>
							</el-tab-pane>
						</el-tabs>
					</div>
				</div>
			</div>
		</el-dialog>

		<el-dialog v-loading="saveLoading" :title="$t('btn_14')" :visible.sync="dialogSpotTimeAdd" append-to-body :close-on-click-modal='false'
			width="450px" top="15%" :before-close="handleClose1" custom-class="dialogBox">
			<div class="dialogBoxMes" style="padding:0 20px;">
				<div class="dialogMes">
          <p><span style="color: #ff0000">*</span>{{$t('label_580')}}</p>
					<div class="mesInput">
						<el-time-picker v-model="tableDataTreeTimeEdit.beginTime" format="HH:mm" value-format="HH:mm"
							:picker-options="{selectableRange:`00:00:00 - 23:59:00`}" :placeholder="$t('input_41')">
						</el-time-picker>
						<span style="position:absolute;right: 35px;bottom: 205px">
							<el-checkbox v-model="beginChecked"></el-checkbox>{{$t('label_151')}}
						</span>
					</div>
				</div>
				<div class="dialogMes">
          <p><span style="color: #ff0000">*</span>{{$t('label_585')}}</p>
					<div class="mesInput">
						<el-time-picker v-model="tableDataTreeTimeEdit.endTime" format="HH:mm" value-format="HH:mm"
							:picker-options="{selectableRange:`00:00:00 - 23:59:00`}" :placeholder="$t('input_112')">
						</el-time-picker>
						<span style="position:absolute;right: 35px;bottom: 155px">
							<el-checkbox v-model="endChecked"></el-checkbox>{{$t('label_151')}}
						</span>
					</div>
				</div>
				<div class="dialogMes">
					<p>{{$t('label_170')}}</p>
					<div class="mesInput">
						<el-select v-model="tableDataTreeTimeEdit.user" filterable remote reserve-keyword
							:placeholder="$t('input_66')" :remote-method="remoteMethod" :loading="loading" style="width: 220px;">
							<el-option v-for="item in options" :key="item.id" :label="item.fullName"
								:value="`${item.id}&@${item.fullName}`">
								<span style="float: left">{{item.fullName}}</span>
							</el-option>
						</el-select>
					</div>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<div class="chooseButton sendButton" @click="timeAddSave">{{$t('btn_13')}}</div>
			</span>
		</el-dialog>

		<el-dialog v-loading="saveLoading" :title="$t('btn_15')" :visible.sync="dialogSpotTimeEdit" append-to-body :close-on-click-modal='false'
			width="450px" top="15%" :before-close="handleClose1" custom-class="dialogBox">
			<div class="dialogBoxMes" style="padding:0 20px;">
				<div class="dialogMes">
          <p><span style="color: #ff0000">*</span>{{$t('label_580')}}</p>
					<div class="mesInput">
						<el-time-picker v-model="tableDataTreeTimeEdit.beginTime" format="HH:mm" value-format="HH:mm"
							:picker-options="{selectableRange:`00:00:00 - 23:59:00`}" :placeholder="$t('input_41')">
						</el-time-picker>
						<span style="position:absolute;right: 35px;bottom: 205px">
							<el-checkbox v-model="beginChecked"></el-checkbox>{{$t('label_151')}}
						</span>
					</div>
				</div>
				<div class="dialogMes">
          <p><span style="color: #ff0000">*</span>{{$t('label_585')}}</p>
					<div class="mesInput">
						<el-time-picker v-model="tableDataTreeTimeEdit.endTime" format="HH:mm" value-format="HH:mm"
							:picker-options="{selectableRange:`00:00:00 - 23:59:00`}" :placeholder="$t('input_112')">
						</el-time-picker>
						<span style="position:absolute;right: 35px;bottom: 155px">
							<el-checkbox v-model="endChecked"></el-checkbox>{{$t('label_151')}}
						</span>
					</div>
				</div>
				<div class="dialogMes">
          <p><span style="color: #ff0000">*</span>{{$t('label_170')}}</p>
					<div class="mesInput">
						<el-select v-model="tableDataTreeTimeEdit.user" filterable remote reserve-keyword
							:placeholder="$t('input_66')" :remote-method="remoteMethod" :loading="loading" style="width: 220px;">
							<el-option v-for="item in options" :key="item.id" :label="item.fullName"
								:value="`${item.id}&@${item.fullName}`">
								<span style="float: left">{{item.fullName}}</span>
							</el-option>
						</el-select>
					</div>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<div class="chooseButton sendButton" @click="timeUpdateSave">{{$t('btn_13')}}</div>
			</span>
		</el-dialog>

		<el-dialog :title="$t('btn_38')" :visible.sync="dialogFactory1" append-to-body
			:close-on-click-modal='false' width="1000px" top="5%" :before-close="handleClose" custom-class="dialogBox"
			style='height:900px;'>
			<div class="dialogBoxMes" style="padding:0 20px;">
				<div class="dialogMes">
					<div class="dialogMes">
						<p>{{$t('label_128')}}</p>
						<div class="mesInput">
							<el-input v-model="dialogFactoryEdit.name" :disabled="true" :placeholder="$t('input_9')" @change="change"
								clearable></el-input>
						</div>
					</div>
					<div class="dialogMes" style="margin-left: 30px">
						<p>{{$t('label_567')}}</p>
						<div class="mesInput">
							<el-select style="width:230px;" @change="changeDeptName"
								v-model="dialogFactoryEdit.deptName" :disabled="true" :placeholder="$t('input_65')">
								<el-option v-for="item in dialogFactoryEditDeptName" :key="item.id" :label="item.name"
									:value="item.name">
								</el-option>
							</el-select>
						</div>
					</div>
				</div>
				<div class="dialogMes">
					<div class="dialogMes">
						<p>{{$t('label_481')}}</p>
						<div class="mesInput">
							<el-date-picker style="width:210px;" value-format="yyyy-MM-dd HH:mm:ss"
								v-model="dialogFactoryEdit.inspectionBeginTime" :disabled="true" type="datetime" placeholder="选择启用时间"
								@change="change">
							</el-date-picker>
						</div>
					</div>
					<div class="dialogMes" style="margin-left: 30px">
						<p>{{$t('label_109')}}</p>
						<div class="mesInput">
							<el-input style="width:230px;" :disabled="true" v-model="dialogFactoryEdit.userName"
								clearable></el-input>
						</div>
					</div>
				</div>
				<div class="treeMes">
					<div class="spotMesBox" style="height:100%;">
						<el-tabs v-model="activeNameSpot" @tab-click="tabClick">
							<el-tab-pane :label="$t('label_140')" name="inspectionEquipment">
								<inspectionEquipment :showButton="!dialogFactoryAdd" :showEdit="false" ref="inspectinDevice">
								</inspectionEquipment>
							</el-tab-pane>
							<el-tab-pane :label="$t('label_143')" name="pro">
								<inspectionProject ref="inspectinDevice1" :showEdit="false"></inspectionProject>
							</el-tab-pane>
							<el-tab-pane :label="$t('label_147')" name="bao">
								<el-table :empty-text="$t('label_357')" ref="singleTable" :data="tableDataTreeTime" highlight-current-row
									@current-change="handleCurrentChangeTreeTime" border
									style="width: 100%;height:100%;margin: 10px 0px;" height="300px"
									:header-cell-style="{'background-color': '#45494f','color': '#ffffff',}">
									<el-table-column header-align="center" align="center" :label="$t('label_369') + '.'" type="index"
										:index="getIndexTime" width="50">
									</el-table-column>
									<el-table-column prop="beginTime" :label="$t('label_580')" align="center">
										<template slot-scope="scope">
											<p>{{scope.row.beginTime}}
												<span v-if="scope.row.beginTimeOverDay==1">{{$t('label_151')}}</span>
											</p>
										</template>
									</el-table-column>
									<el-table-column prop="endTime" :label="$t('label_585')" align="center">
										<template slot-scope="scope">
											<p>{{scope.row.endTime}}
												<span v-if="scope.row.endTimeOverDay==1">{{$t('label_151')}}</span>
											</p>
										</template>
									</el-table-column>
									<el-table-column prop="duration" :label="$t('label_155')" align="center">
									</el-table-column>
									<el-table-column prop="userName" :label="$t('label_109')" align="center">
									</el-table-column>
								</el-table>
								<Page class="item" ref="pageModelTime" :total="pageCountTime" :display="pageSizeTime"
									:pagegroup="3" :currentspage="1" @parentMethod="selectTime"></Page>
							</el-tab-pane>
							<el-tab-pane :label="$t('btn_59')" name="xun"
								v-if="MenuRoleList.indexOf('21')>=0">
								<div style="height:370px;">
									<calendar ref="calendarDisplay" @saveRest="saveRest" :showButton="false"
										:showEdit="false" :calendarData="calendarData"
										@selectRest="selectRest"></calendar>
								</div>
							</el-tab-pane>
						</el-tabs>
					</div>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import "@/assets/css/map/map.css"
	import "@/assets/css/common/spot.css"
	import Page from "@/components/common/page";
	import TimePage from "@/assets/js/timePage/timePage.js";
	import utils from '@/utils/utils'
	import calendar from "@/components/list/calendar/calendar";
	import file from "@/assets/js/file/file.js";
	import exportMes from "@/components/list/export/export";
	import popMesBox from "@/components/list/popover/pop";
	import inspectionEquipment from "@/components/list/displayPage/inspectionEquipment";
	import inspectionProject from "@/components/list/displayPage/inspectionProject";
	import inspectionTime from "@/components/list/displayPage/inspectionTime";
	import restDay from "@/components/list/displayPage/restDay";
	import inspection from "@/assets/js/inspection/inspection.js";
	import moment from 'moment'

	export default {
		name: 'EquipmentInspection',
		components: {
			Page,
			calendar,
			exportMes,
			popMesBox,
			inspectionEquipment,
			inspectionProject,
			inspectionTime,
			restDay,
		},
		data() {
			return {
        saveLoading: false,
				pageNum: 1,
				select: 0,
				pageSize: 10,
				pageCount: 0,
				pageNumTime: 1,
				pageSizeTime: 10,
				pageCountTime: 0,
				Readytime: '',
				height: 620,
				MenuRoleList: [],
				calendarData: [],
				//restDayData: [],
				spotStatusNumList: [{
					icon: 'el-icon-check',
					type: '2',
					text: this.$t('btn_36'),
					check: true,
					num: '0',
					color: '#3fb393'
				}, {
					icon: 'el-icon-close',
					type: '3',
					text: this.$t('btn_37'),
					check: true,
					num: '0',
					color: '#e60000'
				}],
				dialogFactoryEdit: {
					id: '',
					name: "",
					inspectionBeginTime: "",
					deptName: "",
					userName: "",
				},
				dialogFactoryEditDeptName: [],
				tableDatadialog: [],
				cardData: [],
				allTableData: [],
				tableDataTreeInfo: {}, //页面数据
				factoryDialogTitle: this.$t('btn_14'), //弹出框的标题
				getTreeMes: '1',
				dialogFactory: false, //弹出框的当前状态
				dialogFactory1: false,
				dialogFactoryAdd: true, //弹出框的当前状态
				beginChecked: false,
				endChecked: false,
				dialogSpotTimeAdd: false,
				dialogSpotTimeEdit: false,
				dialogSpotTimeDelete: false,
				commitFlag: true,
				searchDataList: {
					id: '',
					name: '',
					deptId: '',
					userId: '',
					deptName: '',
					userName: '',
					inspectionStatus: [],
					idList: [],
					type: ''
				},
				tableDataTreeTime: [],
				tableDataTreeTimeExport: [], //页面导出的数据
				tableDataTree: [],
				defaultProps: {
					children: 'children',
					label: 'label'
				},
				activeNameSpot: 'inspectionEquipment',
				factoryTypeList: [],
				multipleSelection: [],
				tableDataTreeTimeEdit: {
					id: '',
					equipmentInspectionPlanId: '',
					beginTime: '',
					endTime: '',
					beginTimeOverDay: '',
					endTimeOverDay: '',
					userName: '',
					userId: '',
					user: ''
				},
				calendarList: {
					id: '',
					year: moment().format('YYYY')
				},
				tableDataTreeTimeInfo: {},
				options: [],
				loading: false,
				inspStatus: [],
			}
		},
		methods: {
			search() {
				let param = {
					pageNum: 1,
					pageSize: this.pageSize
				}
				this.searchPage(param);
			},
			changeDeptName(event) {
				for (var i = 0; i < this.dialogFactoryEditDeptName.length; i++) {
					if (event == this.dialogFactoryEditDeptName[i].name) {
						this.dialogFactoryEdit.deptId = this.dialogFactoryEditDeptName[i].id;
						break
					}
				}
			},
			//分页查询
			searchPage(param) {
				for (var i = 0; i < this.spotStatusNumList.length; i++) {
					if (this.spotStatusNumList[i].check) {
						this.searchDataList.inspectionStatus.push(this.spotStatusNumList[i].type);
					}
				}
				var dataParam = this.searchDataList;
				var newParam = Object.assign(param, dataParam);
				this.selectStatus(newParam);
				this.pageNum = newParam.pageNum;
				this.pageSize = newParam.pageSize;
				this.selectInspectionPage(newParam);
			},
			tabClick() {
				this.$refs.inspectinDevice1.tableData = [];
				this.$refs.inspectinDevice1.getDeviceList(this.dialogFactoryEdit.id);
			},
			getIndex(index) {
				return (this.pageNum - 1) * this.pageSize + index + 1
			},
			getIndexTime(index) {
				return (this.pageNumTime - 1) * this.pageSizeTime + index + 1
			},
			updateStatus(param) {
				if(param == 1) {
				for (var i = 0; i < this.inspStatus.length; i++) {
					if (this.inspStatus[i].toString() != '3') {
						this.$message({
							message: this.$t('msg_241'),
							type: 'error'
						});
						return;
					}
				 }
				}
				if (this.multipleSelection.length > 0) {
					this.searchDataList.idList = this.multipleSelection;
					this.searchDataList.type = param;
					this.$confirm(this.$t('label_180'), this.$t('label_358'), {
						confirmButtonText: this.$t('label_100'),
						cancelButtonText: this.$t('btn_1'),
						type: 'warning'
					}).then(() => {
						inspection.updateStatus(this.searchDataList).then((response) => {
							const data = response.data;
							if (data.code == "1") {
								let param1 = {
									pageNum: 1,
									pageSize: this.pageSize,
								}
								this.searchPage(param1);
							} else {
								utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
							}
						}).catch((response) => {
							console.log(response)
						})
					}).catch(() => {

					});
				} else {
					utils.messageAlert(this.$t('input_38'), this.$t('label_358'), this.$t('label_100'));
				}
			},
			updateStatus1(param) {
				this.searchDataList.idList.push(this.dialogFactoryEdit.id);
				this.searchDataList.type = param;
				if (this.$refs.inspectinDevice.tableData.length == 0) {
					utils.messageAlert(this.$t('input_10'), this.$t('label_358'), this.$t('label_100'));
					return false
				}
				if (this.tableDataTreeTime.length == 0) {
					utils.messageAlert(this.$t('input_11'), this.$t('label_358'), this.$t('label_100'));
					return false
				}
				this.$confirm(this.$t('label_180'), this.$t('label_358'), {
					confirmButtonText: this.$t('label_100'),
					cancelButtonText: this.$t('btn_1'),
					type: 'warning'
				}).then(() => {
					inspection.updateStatus(this.searchDataList).then((response) => {
						const data = response.data;
						if (data.code == "1") {
							this.dialogFactory = false;
							let param1 = {
								pageNum: 1,
								pageSize: this.pageSize,
							}
							this.searchPage(param1);
						} else {
							utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
						}
					}).catch((response) => {
						console.log(response)
					})
				}).catch(() => {

				});
			},
			selectProp: function(index) {
				console.log(index)
				this.select = index
			},
			//单选
			handleChange(selection) {
				console.log(selection)
				this.multipleSelection = [];
				this.inspStatus = [];
					this.tableDataTreeInfo =selection[0];
				for (var i = 0; i < selection.length; i++) {
					this.multipleSelection.push(selection[i].id);
					this.inspStatus.push(selection[i].inspectionStatus);
				}
			},
			selectRest(param) {
				var dataParam = {
					id: this.dialogFactoryEdit.id,
				}
				var newParam = Object.assign(param, dataParam);
				inspection.selectRest(newParam).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.calendarData = data.data;
					}
				}).catch((response) => {
					console.log(response)
				})
			},

			//点击编辑选中的数据
			addFactory(title) {
				this.factoryDialogTitle = title;
				this.activeNameSpot = 'inspectionEquipment';
				console.log(this.multipleSelection)
				if (title != this.$t('btn_14')) {
					if(this.multipleSelection.length>1||this.multipleSelection.length==0){
						utils.messageAlert(this.$t('msg_240'));
					}else{
					console.log(this.tableDataTreeInfo)
					if (Object.keys(this.tableDataTreeInfo).length > 0) {
						if (this.tableDataTreeInfo.inspectionStatus.toString() != 3) {
							this.$message({
								message: this.$t('msg_44'),
								type: 'error'
							});
							return;
						}
						this.dialogFactory = true;
						this.dialogFactoryAdd = false;
						// this.dialogFactoryEdit = this.tableDataTreeInfo;
						this.tableDataTreeTimeEdit.equipmentInspectionPlanId = this.tableDataTreeInfo.id,
						this.dialogFactoryEdit.id = this.tableDataTreeInfo.id;
						this.dialogFactoryEdit.name = this.tableDataTreeInfo.name;
						this.dialogFactoryEdit.inspectionBeginTime = this.tableDataTreeInfo.inspectionBeginTime;
						this.dialogFactoryEdit.deptName = this.tableDataTreeInfo.deptName;
						this.dialogFactoryEdit.userName = this.tableDataTreeInfo.userName;
						this.dialogFactoryEdit.inspectionStatus = this.tableDataTreeInfo.inspectionStatus;
						this.calendarList.id = this.tableDataTreeInfo.id;
						if (this.dialogFactoryEdit != null && this.dialogFactoryEdit != '') {
							this.commitFlag = false;
						}
						this.$nextTick(() => {
							this.$refs.inspectinDevice.tableData = [];
							this.$refs.inspectinDevice1.tableData = [];
							this.$refs.inspectinDevice.getDeviceList(this.dialogFactoryEdit.id);
							this.$refs.inspectinDevice1.getDeviceList(this.dialogFactoryEdit.id);
							this.calendarList.year = this.$refs.calendarDisplay.year;
						})
						this.selectTimeData();
						this.selectRestList();
					} else {
						utils.messageAlert(this.$t('input_38'), this.$t('label_358'), this.$t('label_100'));
					}
					}
				} else {
					let userList = this.$store.getters.getCurrentUser;
					this.dialogFactoryEdit.id = '';
					this.dialogFactoryEdit.name = '';
					this.dialogFactoryEdit.inspectionBeginTime = '';
					this.dialogFactoryEdit.deptName = '';
					this.dialogFactoryEdit.inspectionStatus = '';
					this.dialogFactoryEdit.userName = userList.name;
					this.dialogFactoryEdit.userId = userList.userId;
					this.dialogFactory = true;
					this.dialogFactoryAdd = true;
					this.commitFlag = true;
					this.$nextTick(() => {
						this.$refs.inspectinDevice1.tableData = [];
						this.tableDataTreeTime = [];
						this.calendarData = [];
					})
					inspection.selectName(userList.userId).then((response) => {
						const data = response.data;
						if (data.code == "1") {
							this.dialogFactoryEditDeptName = data.data;
							this.dialogFactoryEdit.deptName = this.dialogFactoryEditDeptName[0].name;
							this.dialogFactoryEdit.deptId = this.dialogFactoryEditDeptName[0].id;
						}
					}).catch((response) => {
						console.log(response)
					})
					this.$nextTick(() => {
						this.$refs.inspectinDevice.getDeviceList('');
					})
				}
			},
			look() {
				this.activeNameSpot = 'inspectionEquipment'
				if (Object.keys(this.tableDataTreeInfo).length > 0) {
					this.dialogFactory1 = true;
					this.dialogFactoryAdd = false;
					this.tableDataTreeTimeEdit.equipmentInspectionPlanId = this.tableDataTreeInfo.id,
					this.dialogFactoryEdit.id = this.tableDataTreeInfo.id;
					this.dialogFactoryEdit.name = this.tableDataTreeInfo.name;
					this.dialogFactoryEdit.inspectionBeginTime = this.tableDataTreeInfo.inspectionBeginTime;
					this.dialogFactoryEdit.deptName = this.tableDataTreeInfo.deptName;
					this.dialogFactoryEdit.userName = this.tableDataTreeInfo.userName;
					this.dialogFactoryEdit.inspectionStatus = this.tableDataTreeInfo.inspectionStatus;
					this.calendarList.id = this.tableDataTreeInfo.id;
					if (this.dialogFactoryEdit != null && this.dialogFactoryEdit != '') {
						this.commitFlag = false;
					}
					this.$nextTick(() => {
						this.$refs.inspectinDevice.getDeviceList(this.dialogFactoryEdit.id);
						this.$refs.inspectinDevice1.getDeviceList(this.dialogFactoryEdit.id);
						this.calendarList.year = this.$refs.calendarDisplay.year;
					})
					this.selectTimeData();
					this.selectRestList();
				} else {
					utils.messageAlert(this.$t('input_38'), this.$t('label_358'), this.$t('label_100'));
				}
			},
			//弹框关闭再打开清空的方法
			handleClose() {
				this.dialogFactory = false;
				this.dialogFactory1 = false;
				this.search();
			},

			handleClose1() {
				this.dialogDeviceSpot = false;
				this.dialogSpotTimeAdd = false;
				this.dialogSpotTimeEdit = false;
			},

			handleCurrentChangeTree(info) {
				this.tableDataTreeInfo = info;
			},
			handleCurrentChangeTreeTime(info) {
				this.tableDataTreeTimeInfo = info;
			},
			// handleClickSpot(tab, event) {

			// },

			//点击删除按钮
			del() {
				for (var i = 0; i < this.inspStatus.length; i++) {
					if (this.inspStatus[i].toString() != '3') {
						this.$message({
							message: this.$t('msg_45'),
							type: 'error'
						});
						return;
					}
				}
				if (this.multipleSelection.length > 0) {
					this.$confirm(this.$t('msg_66') + '?', this.$t('label_358'), {
						confirmButtonText: this.$t('label_100'),
						cancelButtonText: this.$t('btn_1'),
						type: 'warning'
					}).then(() => {
						inspection.del(this.multipleSelection).then((response) => {
							const data = response.data;
							if (data.code == "1") {
								let param1 = {
									pageNum: 1,
									pageSize: this.pageSize,
								}
								this.searchPage(param1);
							} else {
								utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
							}
						}).catch((response) => {
							console.log(response)
						})
					}).catch(() => {

					});
				} else {
					utils.messageAlert(this.$t('input_38'), this.$t('label_358'), this.$t('label_100'));
				}
			},
			querySearchAsync1(queryString, cb) {
				let param = {
					name: this.searchDataList.deptName
				}
				file.selectDept(param).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						cb(data.data)
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			handleSelect1(item) {
				this.searchDataList.deptName = item.name
				this.searchDataList.deptId = item.id
			},
			querySearchAsync2(queryString, cb) {
				file.selectUser(this.searchDataList.userName).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						cb(data.data)
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			handleSelect2(item) {
				this.searchDataList.userName = item.fullName
				this.searchDataList.userId = item.id
			},
			selectStatus(param) {
				inspection.selectStatus(param).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.spotStatusNumList[0].num = data.data.num0
						this.spotStatusNumList[1].num = data.data.num1
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			selectInspectionPage(param) {
				inspection.selectInspectionPage(param).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.tableDatadialog = data.data.records;
						this.searchDataList.inspectionStatus = [];
						this.multipleSelection = [];
						this.pageSize = data.data.size;
						this.pageCount = data.data.total;
						this.pageNum = data.data.current;
						this.$refs['pageModel'].setCurrent(this.pageNum);
					} else {
						utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			selectTimeData() {
				let param = {
					pageNum: this.pageNumTime,
					pageSize: this.pageSizeTime,
					id: this.dialogFactoryEdit.id
				}
				inspection.selectTimeData(param).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.tableDataTreeTime = data.data.records;
						this.pageSizeTime = data.data.size;
						this.pageCountTime = data.data.total;
						this.pageNumTime = data.data.current;
						this.$refs['pageModelTime'].setCurrent(this.pageNumTime);
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			selectTime(page) {
				let param = {
					equipmentInspectionPlanId: this.dialogFactoryEdit.id
				}
				var newParam = Object.assign(page, param);
				inspection.selectTimeData(newParam).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.tableDataTreeTime = data.data.records;
						this.pageSizeTime = data.data.size;
						this.pageCountTime = data.data.total;
						this.pageNumTime = data.data.current;
						this.$refs['pageModelTime'].setCurrent(this.pageNumTime);
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			timeAdd() {
				this.beginChecked = false;
				this.endChecked = false;
				this.tableDataTreeTimeEdit.beginTime = '';
				this.tableDataTreeTimeEdit.endTime = '';
				this.dialogSpotTimeAdd = true;
			},
			timeAddSave() {
        if (this.tableDataTreeTimeEdit.beginTime == '' || this.tableDataTreeTimeEdit.beginTime == null) {
          utils.messageAlert(this.$t('msg_40'));
          this.saveLoading = false;
          return;
        }
        if (this.tableDataTreeTimeEdit.endTime == '' || this.tableDataTreeTimeEdit.endTime == null) {
          utils.messageAlert(this.$t('msg_41'));
          this.saveLoading = false;
          return;
        }
        if (this.tableDataTreeTimeEdit.user == '' || this.tableDataTreeTimeEdit.user == null) {
          utils.messageAlert(this.$t('input_12'));
          this.saveLoading = false;
          return;
        }
        this.saveLoading = true;
				if (this.beginChecked) {
					this.tableDataTreeTimeEdit.beginTimeOverDay = 1;
				} else {
					this.tableDataTreeTimeEdit.beginTimeOverDay = 0;
				}
				if (this.endChecked) {
					this.tableDataTreeTimeEdit.endTimeOverDay = 1;
				} else {
					this.tableDataTreeTimeEdit.endTimeOverDay = 0;
				}
				let arr = this.tableDataTreeTimeEdit.user.split("&@");
				this.tableDataTreeTimeEdit.userId = arr[0];
				this.tableDataTreeTimeEdit.userName = arr[1];
				if (this.tableDataTreeTimeEdit.user == null || this.tableDataTreeTimeEdit.user == "") {
					this.$message({
						message: this.$t('input_12'),
						type: 'error'
					});
          this.saveLoading = false;
					return;
				}
				inspection.timeAddSave(this.tableDataTreeTimeEdit).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.selectTimeData();
						this.dialogSpotTimeAdd = false;
					} else {
						utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
					}
          this.saveLoading = false;
				}).catch((response) => {
					console.log(response)
          this.saveLoading = false;
				})
			},
			timeUpdate() {
				if (this.tableDataTreeTimeInfo != null && Object.keys(this.tableDataTreeTimeInfo).length > 0) {
					if (this.tableDataTreeTimeInfo.beginTimeOverDay == 0) {
						this.beginChecked = false;
					} else {
						this.beginChecked = true;
					}
					if (this.tableDataTreeTimeInfo.endTimeOverDay == 0) {
						this.endChecked = false;
					} else {
						this.endChecked = true;
					}
					this.tableDataTreeTimeEdit.beginTime = this.tableDataTreeTimeInfo.beginTime;
					this.tableDataTreeTimeEdit.endTime = this.tableDataTreeTimeInfo.endTime;
					this.tableDataTreeTimeEdit.id = this.tableDataTreeTimeInfo.id;
					this.options = [{
						id: this.tableDataTreeTimeInfo.userId,
						fullName: this.tableDataTreeTimeInfo.userName
					}];
					this.tableDataTreeTimeEdit.user = this.tableDataTreeTimeInfo.userId + '&@' + this.tableDataTreeTimeInfo
						.userName;
					this.tableDataTreeTimeEdit.userId = this.tableDataTreeTimeInfo.userId;
					this.tableDataTreeTimeEdit.userName = this.tableDataTreeTimeInfo.userName;
					this.dialogSpotTimeEdit = true;
				} else {
					utils.messageAlert(this.$t('input_38'), this.$t('label_358'), this.$t('label_100'));
				}
			},
			timeUpdateSave() {
        console.log("时间" + this.tableDataTreeTimeEdit.beginTime)
        if (this.tableDataTreeTimeEdit.beginTime == '' || this.tableDataTreeTimeEdit.beginTime == null) {
          utils.messageAlert(this.$t('msg_40'));
          this.saveLoading = false;
          return;
        }
        if (this.tableDataTreeTimeEdit.endTime == '' || this.tableDataTreeTimeEdit.endTime == null) {
          utils.messageAlert(this.$t('msg_41'));
          this.saveLoading = false;
          return;
        }
        if (this.tableDataTreeTimeEdit.user == '' || this.tableDataTreeTimeEdit.user == null) {
          utils.messageAlert(this.$t('input_12'));
          this.saveLoading = false;
          return;
        }
        this.saveLoading = true;
				if (this.beginChecked) {
					this.tableDataTreeTimeEdit.beginTimeOverDay = 1;
				} else {
					this.tableDataTreeTimeEdit.beginTimeOverDay = 0;
				}
				if (this.endChecked) {
					this.tableDataTreeTimeEdit.endTimeOverDay = 1;
				} else {
					this.tableDataTreeTimeEdit.endTimeOverDay = 0;
				}
				let arr = this.tableDataTreeTimeEdit.user.split("&@");
				this.tableDataTreeTimeEdit.userId = arr[0];
				this.tableDataTreeTimeEdit.userName = arr[1];
				if (this.tableDataTreeTimeEdit.user == null || this.tableDataTreeTimeEdit.user == "") {
					this.$message({
						message: this.$t('input_12'),
						type: 'error'
					});
          this.saveLoading = false;
					return;
				}
				inspection.timeUpdateSave(this.tableDataTreeTimeEdit).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.selectTimeData();
						this.dialogSpotTimeEdit = false;
					}
          this.saveLoading = false;
				}).catch((response) => {
					console.log(response)
          this.saveLoading = false;
				})
			},
			timeDelete() {
				let param = this.tableDataTreeTimeInfo.id;
				if (Object.keys(this.tableDataTreeTimeInfo).length > 0) {
					this.$confirm(this.$t('msg_66') + '?', this.$t('label_358'), {
						confirmButtonText: this.$t('label_100'),
						cancelButtonText: this.$t('btn_1'),
						type: 'warning'
					}).then(() => {
						inspection.timeDelete(param).then((response) => {
							const data = response.data;
							if (data.code == "1") {
								this.selectTimeData();
							} else {
								utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
							}
						}).catch((response) => {
							console.log(response)
						})
					}).catch(() => {

					});
				} else {
					utils.messageAlert(this.$t('input_38'), this.$t('label_358'), this.$t('label_100'));
				}
			},
			saveRest(param) {
				var dataParam = {
					id: this.dialogFactoryEdit.id
				}
				var newParam = Object.assign(param, dataParam);
				inspection.saveInspectionRest(newParam).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.$message({
							message: this.$t('msg_21'),
							type: 'success'
						});
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			selectRestList() {
				this.calendarData = [];
				inspection.selectRest(this.calendarList).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.calendarData = data.data;
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			insert() {
				if(this.dialogFactoryEdit.name==''||this.dialogFactoryEdit.name==null){
					utils.messageAlert(this.$t('input_9'), this.$t('label_358'), this.$t('label_100'));
					return;
				}
				if(this.dialogFactoryEdit.inspectionBeginTime==''||this.dialogFactoryEdit.inspectionBeginTime==null){
					utils.messageAlert(this.$t('input_13'), this.$t('label_358'), this.$t('label_100'));
					return;
				}
				this.dialogFactoryEdit.inspectionStatus = [];
				inspection.add(this.dialogFactoryEdit).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.dialogFactoryEdit.id = data.data;
						this.$nextTick(() => {
							this.$refs.inspectinDevice.getDeviceList(this.dialogFactoryEdit.id);
							this.$refs.inspectinDevice1.getDeviceList(this.dialogFactoryEdit.id);
							this.tableDataTreeTimeEdit.equipmentInspectionPlanId = this.dialogFactoryEdit.id;
						})
						this.commitFlag = false;
						this.dialogFactoryAdd = false;
            this.calendarData = [];
						let param1 = {
							pageNum: 1,
							pageSize: this.pageSize,
						}
						this.searchPage(param1);
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			change() {
				this.commitFlag = true;
			},
			remoteMethod(query) {
				if (query !== '') {
					this.loading = true;
					file.repairTaskNum(query).then((response) => {
						const data = response.data;
						if (data.code == "1") {
							this.loading = false;
							this.options = data.data;
						}
					}).catch((response) => {
						this.loading = false;
						console.log(response)
					})
				} else {
					this.options = [];
				}
			},
		},
		mounted() {
			// document.querySelector('.main-content').style.height = (screen.availHeight + 80) + 'px';
		},
		created() {
			this.MenuRoleList = this.$store.getters.getMenu;
			// this.getPartsinformation({
			// 	"pageNum": 1,
			// 	"pageSize": 8,
			// })
			this.search();
		}
	}
</script>

<style scoped>
	.buttonBox .chooseButton {
		margin-left: 5px;
	}

	.spotStatusNumList1 {
		width: 100%;
		display: flex;
	}

	.spotStatusNumList1 .statusMesBox1 {
		display: flex;
		justify-content: space-around;
		width: 15%;
		border: 1px solid #dcdcdc;
		background: #efefef;
		padding: 15px 0;
		margin: 12px;
	}

	.spotStatusNumList1 .statusMesBox1 .iconBox {
		width: 50px;
		height: 50px;
		border-radius: 50px;
		text-align: center;
	}

	.spotStatusNumList1 .statusMesBox1.check {
		border: 1px solid #3fb393;
	}

	.spotStatusNumList1 .statusMesBox1 i {
		font-size: 30px;
		color: #ffffff;
		line-height: 50px;
	}

	.spotStatusNumList1 .statusMesBox1 .num {
		font-size: 30px;
		font-weight: bold;
		color: #9A9A9A;
	}

	.el-dialog__wrapper {
		overflow-y: hidden !important;
	}

	.spotStatusNumList1 .statusMesBox1 .greenFont {
		color: #3fb393;
	}
</style>
<style>

</style>



// WEBPACK FOOTER //
// src/pages/dailyInspection/EquipmentInspection.vue